import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssigmentService, BillService } from 'app/open-api';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { DatePipe, CurrencyPipe } from '@angular/common';
import Swal from 'sweetalert2';
import { BillSummaryShipmentRQ, ShimpmentStates, BillSummaryShipmentToExport, BillSummaryShipmentRP, BillSummaryShipment } from './../../open-api/model/billSummaryShipmentRQ'
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as XLSX from 'xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-bill-summary-shipment",
  templateUrl: "./bill-summary-shipment.component.html",
  styleUrls: ["./bill-summary-shipment.component.scss"],
  providers: [DatePipe, CurrencyPipe],
})
export class BillSummaryShipmentComponent implements OnInit {
  public basicSelectedOption: number = 5;
  shipmentId?: string;
  bills?: BillSummaryShipment[] = [];
  allBills?: BillSummaryShipment[] = [];
  public ColumnMode = ColumnMode;
  noShipment?: string = "";
  isCollapsed = true;
  states?: ShimpmentStates[] = [];

  constructor(
    private billService: BillService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private location: Location,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe
  ) {
    this.shipmentId = this.route.snapshot.paramMap.get("shippingId");
    /*if (this.shipmentId) {
      this.isEditMode = true;
    }*/
  }

  ngOnInit() {
    this.FetchModels();
  }

  FetchModels() {
    this.spinner.show();
    const request: BillSummaryShipmentRQ = {
      shipmentId: +this.shipmentId,
    };

    this.billService
      .apiBillSummaryByShipmentPost(request)
      .subscribe((response) => {
        this.noShipment = response.noShipment;
        this.allBills = this.bills = response.list;
        this.states = response.states;
        this.spinner.hide();
      });
  }

  Back(): void {
    this.location.back();
  }

  FilterUpdate(event) {
    const count = 6;
    if (this.bills.length > 0) {
      let keys = [
        "billCode",
        "billPounds",
        "province",
        "municipality",
        "status",
      ];

      if (event && event !== "") {
        this.bills = this.allBills.filter((item) => {
          // iterate through each row's column data
          for (let i = 0; i < 5; i++) {
            // check for a match
            if (
              (item[keys[i]] &&
                item[keys[i]]
                  .toString()
                  .toLowerCase()
                  .indexOf(event.toLowerCase().trim()) !== -1) ||
              !event.toLowerCase()
            ) {
              // found match, return true to add to result set
              return true;
            }
          }
        });
        //console.log('resultado', this.bills)
        //this.bills = this.searchBills.filter(x => x.code.toLowerCase().indexOf(event.toLowerCase()) > -1);
      } else {
        this.bills = this.allBills;
      }
    }
  }

  totalPounds(){    
    if(this.bills.length > 0){
      let sum = this.bills.reduce((accumulator, item) => {
        return accumulator + Number(Number(item.billPounds).toFixed(2));
      },0);   
      return sum; 
    }
    return 0;    
  }

  export() {
    const swal = Swal.fire({
      title: "Escoja la opción de exportar datos.",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Excel",
      cancelButtonText: "PDF",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {      
      if (result.isConfirmed) {
        this.exportexcel();
      } else if (
        result.isDismissed &&
        result.dismiss == Swal.DismissReason.cancel
      ) {
        this.generatePDF();
      }
    });
  }

  exportList(): BillSummaryShipmentToExport[] {
    let exportflights: BillSummaryShipmentToExport[] = [];
    if (this.bills)
      this.bills.forEach((row) => {
        let now: BillSummaryShipmentToExport = this.GetBillToExport(row);
        exportflights.push(now);
      });
    return exportflights;
  }

  GetBillToExport(row: BillSummaryShipment) {
    let ret: BillSummaryShipmentToExport = {
      CODIGO: row.billCode,
      PESO: row.billPounds,
      PROVINCIA: row.province,
      MUNICIPIO: row.municipality,
      ESTADO: row.status,
    };
    return ret;
  }

  exportexcel(): void {
    /* pass here the data source */
    let exportobj: any = this.exportList();  
   
    const header = [
      ['Resumen de facturas para el envio: ' + this.noShipment, '' + '']];

    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, header);

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, exportobj, { origin: 'A2',  skipHeader: false });
    ws['!merges'] = [
      XLSX.utils.decode_range('A1:C1'),      
    ];

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let newDate: Date = new Date();
    const fecha = this.datePipe.transform(newDate, "MMM/dd/yyyy");
    let fileName: any = `resumen facturas a vuelo_${this.noShipment}_${fecha}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  generatePDF() {
    this.spinner.show();
    const contenido: string[][] = [];
    contenido.push(["#", "CODIGO", "PESO", "FECHA VUELO", "GASTOS", "ESTADO"]);
    //console.log(this.bills);
    this.bills.forEach((b, index) => {
      contenido.push([
        (index + 1).toString(),
        b.billCode,
        b.billPounds.toFixed(2),
        b.province,
        b.municipality,
        b.status,
      ]);
    });
    const totalColumn: any[] = [];

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "LETTER",
      content: [
        {
          columns: [
            {
              text: "Reporte Resumen de facturas a Envío: " + this.noShipment,
              style: ["title"],
              margin: [0, 10],
            },
          ],
        },
        {
          text: "Fecha: " + this.datePipe.transform(new Date(), "MMM/dd/yyyy"),
          style: ["subtitle"],
          margin: [0, 0],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido,
          },
        },
      ],
      styles: {
        title: {
          fontSize: 22,
          bold: true,
          alignment: "left",
        },
        title2: {
          fontSize: 12,
          bold: true,
          alignment: "right",
        },
        subtitle: {
          fontSize: 14,
          alignment: "left",
        },
        footer: {
          fontSize: 8,
          alignment: "right",
        },
      },
    };
    pdfMake.createPdf(documentDefinition).open();
    this.spinner.hide();
  }
}
